export default "__VITE_ASSET__Cak0PK_M__"